const faction = {
  key: 'faction',
};

export default {
  faction,
};
